import React from 'react';
import { ResizingMode } from '@betterpool/api-types/contests-service';
import GuaranteedPlusBadge from '~/domains/design-system/badges/GuaranteedPlusBadge/GuaranteedPlusBadge';
import { AdditionalPayoutType } from '~/domains/contest/domains/services/interfaces/contest.interface';
import { BadgeGuaranteed, BadgeResizable } from '~/components/shared/Badges/Badges';

interface PrizeBadgeProps {
  resizingMode: ResizingMode;
  isGuaranteedPlusEnabled: boolean;
  additionalPayoutType?: AdditionalPayoutType;
  iconSize?: number;
  size?: 'micro' | 'small' | 'medium' | 'large';
  style?: React.CSSProperties;
  className?: string;
}

function PrizeBadge({
  resizingMode,
  isGuaranteedPlusEnabled,
  additionalPayoutType,
  iconSize = 12,
  size = 'micro',
  style,
  className,
}: PrizeBadgeProps) {
  if (isGuaranteedPlusEnabled && additionalPayoutType === AdditionalPayoutType.GUARANTEED_PLUS) {
    return <GuaranteedPlusBadge size={size} style={style} className={className} />;
  }

  if (resizingMode === ResizingMode.GUARANTEED && !isGuaranteedPlusEnabled) {
    return <BadgeGuaranteed iconSize={iconSize} style={style} className={className} />;
  }

  return null;
}

export default PrizeBadge;
